import BaseTabContent from "./styled";
export default BaseTabContent;